import { render, staticRenderFns } from "./AddCompanyPage.vue?vue&type=template&id=95405d30&"
import script from "./AddCompanyPage.vue?vue&type=script&lang=js&"
export * from "./AddCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95405d30')) {
      api.createRecord('95405d30', component.options)
    } else {
      api.reload('95405d30', component.options)
    }
    module.hot.accept("./AddCompanyPage.vue?vue&type=template&id=95405d30&", function () {
      api.rerender('95405d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddCompanyPage.vue"
export default component.exports